import React from "react";
import { Tooltip } from "antd";
import { Folder } from "../../redux/interfaces/folder.types.ts";
import { WhatsAppOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

interface Props {
  folder: Folder;
}

export const SendWhatsapp: React.FC<Props> = ({ folder }) => {
  const tenant = folder.metadata?.tenant;

  const pending_upload = folder.requirements_summary?.pending_upload || 0;
  const folderLink = `${window.location.origin}/vault/${folder.id}`;
  const whatsappLink = `https://api.whatsapp.com/send/?phone=${tenant?.phone_number}&text=Hola ${tenant?.full_name}, faltan ${pending_upload} requisitos para completar tu expediente. Puedes enviarlos desde tu celular presionando la siguiente liga: ${folderLink}`;

  return (
    <Link to={whatsappLink} target="_blank" rel="noopener noreferrer">
      <Tooltip title="Enviar whatsapp" className="cursor-pointer">
        <WhatsAppOutlined
          style={{ fontSize: "18px" }}
          className="text-gray-600 hover:text-blue-400"
        />
      </Tooltip>
    </Link>
  );
};
